const PageHeader = ({ eyebrow, title, description }) => (
  <div className="dw-bg-base text-center py-16 px-5 border-b" style={{ borderColor: "var(--dw-line)" }}>
    {eyebrow && <div className="dw-eyebrow mb-2">{eyebrow}</div>}
    <h1>{title}</h1>
    {description && (
      <div className="max-w-2xl mx-auto pt-3">
        <p className="dw-mini">{description}</p>
      </div>
    )}
  </div>
);

export default PageHeader;
